import React from "react";
import {Link} from "react-router-dom";
import {Alert,Modal,CardBody,Form,Button,Card} from "reactstrap";
import InputMask from 'react-input-mask';
import NotificationAlert from "react-notification-alert";
import { connect } from 'react-redux';
import readXlsxFile from 'read-excel-file';
import $ from "jquery";
import moment from "moment";
import reduxHelper from "./../../../helper/index.js";
import api from "../../../Api.js";

class ImportXlsxClassRoom extends React.Component {

	constructor(props){

        super(props);
        
        this.setStateTop = this.props.setState;
        this.topState = this.props.topState;

        this.filterClassRoom = this.filterClassRoom.bind(this);
        
        this.state = {
            classRoomList:[],
            importError:"",
            erroXLSX:"",
            verificado:false,
            professors:[],
            professorsCompanyId: null
        };

        this.checkXlsx = this.checkXlsx.bind(this);
        this.reset = this.reset.bind(this);
        this.changeValue = this.changeValue.bind(this);
        this.checkXlsxServer = this.checkXlsxServer.bind(this);
        this.helper = new reduxHelper(this.props);
        this.manual = this.manual.bind(this);
        this.removeLine = this.removeLine.bind(this);
        this.addLine = this.addLine.bind(this);
        this.loadProfessors = this.loadProfessors.bind(this);
        this.changeInstructor = this.changeInstructor.bind(this);
        this.addInstructor = this.addInstructor.bind(this);
        this.removeInstructor = this.removeInstructor.bind(this);

        window.importxlsxclassroom = this;

    }

    componentDidUpdate(prevProps){
        if(this.props.state.openModalImportClassRoom && this.state.classRoomList.length > 0 && this.state.professors.length === 0){
            this.loadProfessors();
        }
    }

    async loadProfessors(){
        const companyId = this.props.state?.company || this.props.user?.preference?.selectcompany;
        const companyKey = companyId || '';
        if(!companyId){
            this.setState({ professors: [], professorsCompanyId: null });
            return [];
        }
        if(this.state.professors.length > 0 && this.state.professorsCompanyId === companyKey){
            return this.state.professors;
        }
        try {
            const ids = {};
            const list = [];
            const add = (arr) => {
                if(!Array.isArray(arr)) return;
                arr.forEach(function(p){
                    if(!p || !p.id || ids[p.id]) return;
                    if(parseInt(p.blocked, 10) === 1) return;
                    ids[p.id] = true;
                    list.push(p);
                });
            };
            const level3 = api.getUsersByCompanyAndAccessLevel(companyId, 3).then(r => r?.data).catch(() => []);
            const level5 = api.getUsersByCompanyAndAccessLevel(companyId, 5).then(r => r?.data).catch(() => []);
            const level9global = api.getUsersByAccessLevel(9).then(r => r?.data).catch(() => []);
            const [professores, diretores, global9] = await Promise.all([level3, level5, level9global]);
            add(professores);
            add(diretores);
            add(global9);
            this.setState({ professors: list, professorsCompanyId: companyKey });
            return list;
        } catch(e) {
            console.error("Erro ao carregar professores", e);
            return [];
        }
    }

    //Para poder reenviar o arquivo xlsx
    reset(){

        this.setState({classRoomList:[],verificado:false});

    }

    //Para remover uma linha da planilha
    removeLine(index){

        var classRoomList = this.state.classRoomList;
        classRoomList.splice(index,1);
        this.setState({classRoomList:classRoomList});
        this.checkXlsxServer();

    }

    //Para adicionar uma linha na planilha
    addLine(){

        var classRoomList = this.state.classRoomList;
        classRoomList.push({name:"",course:"",openingDate:"",closingDate:"",idOnline:"",classTime:"",dayOfTheWeek:[],responsibleTeacher:"",instructors:[{id:"",type:3}]});
        this.setState({classRoomList:classRoomList,verificado:false});

    }

    filterClassRoom(obj){

        var obj2 = JSON.parse(JSON.stringify(obj));
        for (let index = 0; index < obj2.length; index++) {

            obj2[index].openingDate = moment(obj2[index].openingDate,'DD/MM/YYYY').format('YYYY-MM-DD');
            obj2[index].closingDate = moment(obj2[index].closingDate,'DD/MM/YYYY').format('YYYY-MM-DD');
            obj2[index].company = this.props.user.preference.selectcompany;

            if(obj2[index].classTime && obj2[index].classTime.length === 5){
                obj2[index].classTime = obj2[index].classTime + ':00';
            }

            if(!Array.isArray(obj2[index].dayOfTheWeek)){
                obj2[index].dayOfTheWeek = [];
            }

            // Extrai o responsibleTeacher do primeiro instrutor com id preenchido
            var instructors = obj2[index].instructors || [];
            var firstWithId = instructors.find(function(i){ return i.id !== "" && i.id !== null && i.id !== undefined; });
            if(firstWithId){
                obj2[index].responsibleTeacher = parseInt(firstWithId.id, 10) || firstWithId.id;
            } else if(obj2[index].responsibleTeacher !== "" && obj2[index].responsibleTeacher !== undefined){
                obj2[index].responsibleTeacher = parseInt(obj2[index].responsibleTeacher, 10) || obj2[index].responsibleTeacher;
            }

            // Remove o campo instructors do payload — o backend não usa
            delete obj2[index].instructors;
        }

        return obj2;

    }

    //Para verificar os dados do xlsx no servidor
    async checkXlsxServer(){

            var data = await this.helper.classroom().classRoomCheckXlsx(this.filterClassRoom(this.state.classRoomList));
            
            if(!data){
                await this.setState({erroXLSX:'Erro de conexão com o servidor. Tente novamente.'});
                return;
            }
            
            if(parseInt(data.status) === 200){
    
                await this.setState({erroXLSX:'',verificado:true});
    
            }
    
            if(parseInt(data.status) === 400 || parseInt(data.status) === 500){
    
                var msg = data.data?.data?.msg || 'Erro ao validar dados. Verifique os campos.';
    
                await this.setState({erroXLSX:''});
                await this.setState({erroXLSX:msg});
                
    
            }
    
            //console.log(data);
    
    }


    async cadastrar(){

        // Salva os instructors antes de filterClassRoom deletá-los do payload
        var instructorsPerClassroom = this.state.classRoomList.map(function(cr){
            return JSON.parse(JSON.stringify(cr.instructors || []));
        });

        var data = JSON.parse(JSON.stringify(this.filterClassRoom(this.state.classRoomList)));

        for(let index = 0; index < data.length; index++){

            var result = await this.props.postClassRoom(true, data[index]);
            var newClassroomId = (result && result.classroom && result.classroom.id) ? result.classroom.id : (result && result.id ? result.id : null);

            // Adiciona usuários extras (além do responsibleTeacher já inserido pelo backend)
            if(newClassroomId && instructorsPerClassroom[index].length > 0){
                var instructors = instructorsPerClassroom[index];
                // O backend já inseriu o primeiro com id preenchido como responsibleTeacher (type 3)
                var firstId = data[index].responsibleTeacher ? parseInt(data[index].responsibleTeacher, 10) : null;
                var firstSkipped = false;
                for(let u = 0; u < instructors.length; u++){
                    var inst = instructors[u];
                    if(!inst.id && inst.id !== 0) continue;
                    var instId = parseInt(inst.id, 10);
                    // Pula o primeiro match com responsibleTeacher para não duplicar
                    if(!firstSkipped && firstId && instId === firstId){
                        firstSkipped = true;
                        continue;
                    }
                    try {
                        await api.addUserClassRoom({
                            classroom: newClassroomId,
                            user: instId,
                            type: parseInt(inst.type, 10)
                        });
                    } catch(e){ console.error('Erro ao adicionar usuário à turma:', e); }
                }
            }

        }

        this.props.setState({openModalImportClassRoom:false});
        this.reset();

        let options = {place: "tr",message: (<div className="alert-text"><span className="alert-title" data-notify="title">{this.props.translate['sucesso']}!</span><span data-notify="message">{this.props.translate['a_importacao_foi_realizada']}</span></div>),type: 'success',icon: "ni ni-check-bold",autoDismiss: 7};
        this.refs.notificationAlert.notificationAlert(options);
        
        this.props.getAllClassRoom();

    }

    //Para verificar o arquivo enviado
    async checkXlsx(){

        await this.setState({importError:""});

		var input = $('#input_xlsx');
        var file = input[0].files;
        
        $('label[for="input_xlsx"]').html($('#input_xlsx')[0].files[0].name);

        var users = [];

        if(file.length === 0){ this.setState({importError:this.props.translate['voce_deve_selecionar_o_arquivo']}); return false; }
        
        //Tento abrir o arquivo XLSX
        try {
          await readXlsxFile(file[0]).then((rows) => {
            users = rows;
        })   
        } catch (error) {
            this.setState({importError:this.props.translate['nao_foi_possivel_abrir_o_arquivo']});
           // console.log('a1');
            return false;
        }
       
        //Se tiver usuario...
        if(users.length !== 0){

            //Caso não tenha linha de usuario
            if(users.length === 1){

                this.setState({importError:this.props.translate['o_arquivo_enviado_esta_vazio']});
               // console.log('a2');
                return false;

            }

            var professorsList = await this.loadProfessors();

            var classroomscheck = [];

            for(let index = 1; index < users.length; index++) {
                
                var classroomparse = {};
                classroomparse.name = users[index][0];
                
                classroomparse.course = users[index][1];
                classroomparse.idOnline = users[index][4];
                
                classroomparse.openingDate = await moment(users[index][2]).format('DD/MM/YYYY');
                classroomparse.closingDate = await moment(users[index][3]).format('DD/MM/YYYY');
                
                // Processar horário da aula (coluna 5) - planilha pode vir "14:00:00" ou número Excel (fração do dia)
                var rawTime = users[index][5];
                classroomparse.classTime = '';
                if(rawTime != null && rawTime !== ''){
                    if(typeof rawTime === 'number'){
                        if(rawTime >= 0 && rawTime < 1){
                            // Excel: fração do dia (ex: 14/24 = 0,583... para 14:00)
                            var totalMin = Math.round(rawTime * 24 * 60);
                            var h = Math.floor(totalMin / 60) % 24;
                            var m = totalMin % 60;
                            classroomparse.classTime = (h < 10 ? '0' + h : '' + h) + ':' + (m < 10 ? '0' + m : '' + m);
                        } else {
                            // serial date/time: usar UTC para não mudar por fuso
                            classroomparse.classTime = moment.utc(rawTime).format('HH:mm');
                        }
                    } else if(typeof rawTime === 'object' && rawTime instanceof Date){
                        // Date do Excel: usar UTC para manter 14:00 como 14:00 (evita 10:53 por fuso)
                        var utcH = rawTime.getUTCHours();
                        var utcM = rawTime.getUTCMinutes();
                        classroomparse.classTime = (utcH < 10 ? '0' + utcH : '' + utcH) + ':' + (utcM < 10 ? '0' + utcM : '' + utcM);
                    } else {
                        var timeStr = String(rawTime).trim();
                        if(timeStr.match(/^\d{1,2}:\d{2}(:\d{2})?$/)){
                            classroomparse.classTime = timeStr.substring(0, 5);
                        } else {
                            var parsed = moment(timeStr, ['HH:mm:ss', 'HH:mm', 'H:mm'], true);
                            if(parsed.isValid()) classroomparse.classTime = parsed.format('HH:mm');
                            else classroomparse.classTime = timeStr.substring(0, 5);
                        }
                    }
                }

                // Processar dias da semana (coluna 6) - "Segunda-feira", "Segunda, Quarta", "0,1,2", etc.
                classroomparse.dayOfTheWeek = [];
                if(users[index][6] != null && users[index][6] !== ''){
                    const rawDias = users[index][6];
                    const diasMap = {
                        'domingo': '0', 'dom': '0', 'sunday': '0', 'sun': '0',
                        'segunda': '1', 'segunda-feira': '1', 'segunda feira': '1', 'seg': '1', 'monday': '1', 'mon': '1',
                        'terça': '2', 'terça-feira': '2', 'terça feira': '2', 'terca': '2', 'terca-feira': '2', 'terca feira': '2', 'ter': '2', 'tuesday': '2', 'tue': '2',
                        'quarta': '3', 'quarta-feira': '3', 'quarta feira': '3', 'qua': '3', 'wednesday': '3', 'wed': '3',
                        'quinta': '4', 'quinta-feira': '4', 'quinta feira': '4', 'qui': '4', 'thursday': '4', 'thu': '4',
                        'sexta': '5', 'sexta-feira': '5', 'sexta feira': '5', 'sex': '5', 'friday': '5', 'fri': '5',
                        'sábado': '6', 'sabado': '6', 'sab': '6', 'saturday': '6', 'sat': '6'
                    };
                    function normalizarDia(s) {
                        return s.toLowerCase().trim().replace(/\s+/g, ' ').replace(/ç/g, 'c').replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u');
                    }
                    function lookupDia(parte) {
                        var p = parte.trim();
                        if(diasMap[p] !== undefined) return diasMap[p];
                        var norm = normalizarDia(p);
                        for(var k in diasMap){ if(normalizarDia(k) === norm) return diasMap[k]; }
                        return null;
                    }
                    var diasTexto = String(rawDias).toLowerCase().trim();
                    var partes = diasTexto.split(/[,;]+/).map(function(d){ return d.trim(); }).filter(Boolean);
                    partes.forEach(function(parte){
                        var diaVal = lookupDia(parte);
                        if(diaVal !== null && classroomparse.dayOfTheWeek.indexOf(diaVal) === -1){
                            classroomparse.dayOfTheWeek.push(diaVal);
                        } else if(['0','1','2','3','4','5','6'].indexOf(parte) !== -1){
                            if(classroomparse.dayOfTheWeek.indexOf(parte) === -1){
                                classroomparse.dayOfTheWeek.push(parte);
                            }
                        }
                    });
                    classroomparse.dayOfTheWeek.sort();
                }

                classroomparse.instructors = [];
                classroomparse.responsibleTeacher = "";

                const defaultType = (window.app && window.app.state && window.app.state.permitions && window.app.state.permitions.length > 0)
                    ? window.app.state.permitions[0].id
                    : 3;

                function findUserInList(rawName, list){
                    if(!rawName || !list || list.length === 0) return null;
                    const lower = rawName.toLowerCase().trim();
                    const numId = parseInt(rawName, 10);
                    var found = list.find(function(p){ return (p.username||"").toString().toLowerCase().trim() === lower; });
                    if(!found && !isNaN(numId)) found = list.find(function(p){ return parseInt(p.id,10) === numId; });
                    if(!found) found = list.find(function(p){
                        var full = ((p.name||"")+" "+(p.lastName||"")).toLowerCase().trim();
                        return full === lower || (p.name||"").toLowerCase() === lower;
                    });
                    if(!found) found = list.find(function(p){
                        var full = ((p.name||"")+" "+(p.lastName||"")).toLowerCase().trim();
                        var uname = (p.username||"").toString().toLowerCase().trim();
                        return full.indexOf(lower) !== -1 || uname.indexOf(lower) !== -1;
                    });
                    return found || null;
                }

                const instrutorCell = users[index][7] != null && users[index][7] !== "" ? String(users[index][7]).trim() : "";
                if(instrutorCell){
                    var nomes = instrutorCell.split(/[,;]+/).map(function(s){ return s.trim(); }).filter(Boolean);
                    nomes.forEach(function(nome){
                        var found = findUserInList(nome, professorsList);
                        if(found){
                            classroomparse.instructors.push({id: found.id, type: defaultType});
                        }
                    });
                }

                if(classroomparse.instructors.length === 0){
                    classroomparse.instructors = [{id:"", type: defaultType}];
                }
                classroomparse.responsibleTeacher = classroomparse.instructors[0].id || "";

                try {
                    
                    for(let index = 0; index < this.props.state.course.length; index++){
                             
                        if(this.props.state.course[index].name.toLowerCase() === classroomparse.course.toLowerCase()){ 
                            
                            classroomparse.course = this.props.state.course[index].id; 
                            //console.log('setou');

                        }
                                            
                    }

                }catch(error){}
                              
                classroomscheck.push(classroomparse);
                
            }

            await this.setState({classRoomList:classroomscheck,importError:""});
            this.checkXlsxServer();

        }else{

            this.setState({importError:this.props.translate['nao_foi_possivel_abrir_o_arquivo']});
            //console.log('a3');

        }

    }

    changeValue(index,value,position){

        var classRoomList = this.state.classRoomList;
        classRoomList[index][position] = value;
        this.setState({classRoomList:classRoomList,verificado:false});

    }

    changeInstructor(classroomIndex, instructorIndex, field, value){
        var classRoomList = JSON.parse(JSON.stringify(this.state.classRoomList));
        if(!classRoomList[classroomIndex].instructors){
            classRoomList[classroomIndex].instructors = [{id:"", type:3}];
        }
        classRoomList[classroomIndex].instructors[instructorIndex][field] = value;
        this.setState({classRoomList:classRoomList, verificado:false});
    }

    addInstructor(classroomIndex){
        var classRoomList = JSON.parse(JSON.stringify(this.state.classRoomList));
        if(!classRoomList[classroomIndex].instructors){
            classRoomList[classroomIndex].instructors = [];
        }
        var defaultType = (window.app && window.app.state && window.app.state.permitions && window.app.state.permitions.length > 0)
            ? window.app.state.permitions[0].id : 3;
        classRoomList[classroomIndex].instructors.push({id:"", type:defaultType});
        this.setState({classRoomList:classRoomList, verificado:false});
    }

    removeInstructor(classroomIndex, instructorIndex){
        var classRoomList = JSON.parse(JSON.stringify(this.state.classRoomList));
        classRoomList[classroomIndex].instructors.splice(instructorIndex, 1);
        if(classRoomList[classroomIndex].instructors.length === 0){
            classRoomList[classroomIndex].instructors = [{id:"", type:3}];
        }
        this.setState({classRoomList:classRoomList, verificado:false});
    }
    
    //Para abrir o modo de cadastrar manualmente
    async manual(){

        await this.setState({classRoomList:[]});
        this.addLine();

    }

    //Para poder reenviar o arquivo xlsx
   	render(){

        var st = {};
        if(this.state.classRoomList.length !== 0){ st = {maxWidth:'98%'}; }

        return(<React.Fragment>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        <Modal className="modal-dialog-centered" style={st} isOpen={this.props.state.openModalImportClassRoom} >
          <div className="modal-body p-0">
            <Card className="bg-secondary border-0 mb-0">
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">{this.props.translate['importar_por_planilha']}</h6>
                <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={() => { this.props.setState({openModalImportClassRoom:false}); this.reset(); } }><span aria-hidden={true}>×</span> </button>
            </div>
            <CardBody className=" " style={{}}>
                <Form role="form" type="post" onSubmit={ (event) => this.props.saveUser(event) }>
                    {
                        (this.state.importError !== "") &&
                        <Alert color="danger" className="animated tada"><strong>{this.props.translate['ops']}!</strong> {this.state.importError}</Alert>
                    }
                    {

                        (this.state.classRoomList.length === 0) &&
                        <React.Fragment>
                            <center><font>{this.props.translate['selecione_o_arquivo']}:</font></center>
                            <div style={{display:"flex"}}>
                                <div className="custom-file form-control-sm">
                                    <input onChange={ (event) => { this.checkXlsx() } } className="custom-file-input" id="input_xlsx" type="file" />
                                    <label className="custom-file-label " htmlFor="input_xlsx">{this.props.translate['selecionar_arquivo']}</label>
                                </div>
                                <Button onClick={() => this.checkXlsx() } color="secondary" type="button" style={{marginLeft:'5px',height:'44px'}}><i className="ni ni-cloud-upload-96"></i> {this.props.translate['enviar']}</Button>
                            </div>
                        </React.Fragment>

                    }{

                        (this.state.classRoomList.length !== 0) &&
                        <React.Fragment>

                            {

                                (this.state.erroXLSX !== "") &&
                                <div className="container">
                                    <div className="alert alert-danger animated tada" role="alert">
                                        <strong>{this.props.translate['ops']}!</strong> {this.state.erroXLSX}
                                    </div>
                                </div>

                            }
                            {

                                (this.state.erroXLSX === "" && this.state.verificado === true) &&
                                <div className="container">
                                    <div className="alert alert-success animated fadeIn" role="alert">
                                        <strong><i className="fas fa-check"></i></strong> {this.props.translate['tudo_pronto_para_cadastrar']}
                                    </div>
                                </div>

                            }

                            <div className="container table-responsive div_tab_importxlsx">
                                
                                <table className="align-items-center table-flush table">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>#</th>
                                            <th>{this.props.translate['nome']}:</th>
                                            <th>{this.props.translate['curso']}:</th>
                                            <th>{this.props.translate['data_de_abertura']}:</th>
                                            <th>{this.props.translate['data_de_fechamento']}:</th>
                                            <th>{this.props.translate['indetificador_online']}:</th>
                                            <th>{this.props.translate['horario'] || 'Horário'}:</th>
                                            <th>{this.props.translate['dias_da_semana'] || 'Dias'}:</th>
                                            <th>{this.props.translate['instrutores'] || 'Instrutores'}:</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody className="table_importXLXS">
                                        {
                                            this.state.classRoomList.map((value,index) => {

                                                return(<tr key={'input_xlsx_'+index}>
                                                    <td>{(index+1)}</td>
                                                    <td><input onChange={ (event) => this.changeValue(index,event.target.value,'name') } style={{width:'90px'}} value={this.state.classRoomList[index].name}/></td>
                                                    <td>
                                                        <select value={this.state.classRoomList[index].course} onChange={ (event) => this.changeValue(index,event.target.value,'course') }>
                                                            <option value=""></option>
                                                            {

                                                                this.props.state.course.map((value3,index3) => {

                                                                    return(<option value={value3.id} key={"i"+index+"iic"+index3}>{value3.name}</option>)

                                                                })

                                                            }
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <InputMask onChange={ (event) => this.changeValue(index,event.target.value,'openingDate') } value={this.state.classRoomList[index].openingDate} mask="99/99/9999" maskChar="" onFocus={() => this.setState({ focusedNascimento: true }) } onBlur={() => this.setState({ focusedNascimento: false }) }/>
                                                    </td>
                                                    <td>
                                                        <InputMask onChange={ (event) => this.changeValue(index,event.target.value,'closingDate') } value={this.state.classRoomList[index].closingDate} mask="99/99/9999" maskChar="" />
                                                    </td>
                                                    <td>
                                                        <input onChange={ (event) => this.changeValue(index,event.target.value,'idOnline') } value={this.state.classRoomList[index].idOnline} style={{width:'90px'}} placeholder="ID online" />
                                                    </td>
                                                    <td>
                                                        <InputMask onChange={ (event) => this.changeValue(index,event.target.value,'classTime') } value={this.state.classRoomList[index].classTime || ''} mask="99:99" maskChar="" placeholder="HH:MM" style={{width:'70px'}}/>
                                                    </td>
                                                    <td>
                                                        <select 
                                                            multiple 
                                                            value={this.state.classRoomList[index].dayOfTheWeek || []} 
                                                            onChange={ (event) => {
                                                                const selected = Array.from(event.target.selectedOptions, option => option.value);
                                                                this.changeValue(index, selected, 'dayOfTheWeek');
                                                            }}
                                                            style={{width:'100px', height:'60px', fontSize:'0.75rem'}}
                                                        >
                                                            <option value="0">Dom</option>
                                                            <option value="1">Seg</option>
                                                            <option value="2">Ter</option>
                                                            <option value="3">Qua</option>
                                                            <option value="4">Qui</option>
                                                            <option value="5">Sex</option>
                                                            <option value="6">Sáb</option>
                                                        </select>
                                                    </td>
                                                    <td style={{minWidth:'240px',verticalAlign:'middle'}}>
                                                        <div style={{display:'flex',flexDirection:'column',gap:'3px'}}>
                                                        {
                                                            (this.state.classRoomList[index].instructors || [{id:"",type:3}]).map((inst, instIdx) => {
                                                                var permitions = (window.app && window.app.state && window.app.state.permitions && window.app.state.permitions.length > 0)
                                                                    ? window.app.state.permitions
                                                                    : [{id:3,name:'Professor'},{id:4,name:'Aluno'},{id:6,name:'Diretor'}];
                                                                return (
                                                                    <div key={'inst_'+index+'_'+instIdx} style={{display:'flex',alignItems:'center',gap:'0',background:'#f6f9fc',borderRadius:'6px',overflow:'hidden',border:'1px solid #e9ecef'}}>
                                                                        <select
                                                                            value={inst.id || ""}
                                                                            onChange={(e) => this.changeInstructor(index, instIdx, 'id', e.target.value)}
                                                                            style={{fontSize:'0.75rem',flex:1,border:'none',background:'transparent',padding:'4px 6px',minWidth:'0',outline:'none'}}
                                                                        >
                                                                            <option value="">Usuário...</option>
                                                                            {this.state.professors.map(function(p){
                                                                                return <option value={p.id} key={"p_"+p.id}>{(p.name||"")+(p.lastName?" "+p.lastName:"")+(p.username?" ("+p.username+")":"")}</option>;
                                                                            })}
                                                                        </select>
                                                                        <span style={{color:'#dee2e6',userSelect:'none',padding:'0 2px'}}>|</span>
                                                                        <select
                                                                            value={inst.type || 3}
                                                                            onChange={(e) => this.changeInstructor(index, instIdx, 'type', parseInt(e.target.value,10))}
                                                                            style={{fontSize:'0.75rem',width:'84px',border:'none',background:'transparent',padding:'4px 4px',outline:'none'}}
                                                                        >
                                                                            {permitions.map(function(perm,pi){
                                                                                return <option value={perm.id} key={"perm_"+pi}>{perm.name}</option>;
                                                                            })}
                                                                        </select>
                                                                        {instIdx > 0 &&
                                                                            <button type="button" onClick={() => this.removeInstructor(index, instIdx)} style={{border:'none',background:'none',color:'#adb5bd',cursor:'pointer',padding:'4px 6px',fontSize:'0.8rem',lineHeight:1,flexShrink:0}} title="Remover">×</button>
                                                                        }
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                        <button
                                                            type="button"
                                                            onClick={() => this.addInstructor(index)}
                                                            style={{fontSize:'0.72rem',color:'#8898aa',border:'1px dashed #dee2e6',borderRadius:'6px',background:'none',padding:'3px 8px',cursor:'pointer',textAlign:'center',width:'100%',marginTop:'1px'}}
                                                        >
                                                            + instrutor
                                                        </button>
                                                        </div>
                                                    </td>
                                                    <td><i style={{cursor:'pointer'}} onClick={ () => this.removeLine(index) } className="far fa-trash-alt"></i></td>
                                                </tr>)
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </React.Fragment>

                    }
                    <div className="text-center">
                        {   
                            (this.state.classRoomList.length !== 0) &&
                            <Button style={{marginLeft:'10px'}} className="my-4" color="danger" type="button" onClick={ () =>{ this.setStateTop({openModalImport:false}); this.reset(); } }><i className="far fa-times-circle"></i> {this.props.translate['cancelar']}</Button>
                        }
                        
                            <Link target="_blank" download to="/planilha/Template de importacao de turma.xlsx"><Button className="my-4" color="default" type="button" ><i className="fas fa-file-download"></i> {this.props.translate['baixar_template']} </Button></Link>
                        
                        {   
                            (this.state.classRoomList.length === 0) &&
                            <Button style={{marginLeft:'10px'}} className="my-4" color="secondary" type="button" onClick={ () =>{  this.manual(); } }><i className="fas fa-list-ol"></i> {this.props.translate['cadastrar_manualmente']}</Button>
                        }
                        {
                            (this.state.classRoomList.length !== 0) &&
                            <Button style={{marginLeft:'10px'}} className="my-4" color="secondary" type="button" onClick={ () =>{  this.addLine(); } }><i className="fas fa-plus"></i> {this.props.translate['adicionar_linha']}</Button>

                        }
                        {
                            (this.state.classRoomList.length !== 0) &&
                            <React.Fragment>
                                {

                                    (this.state.verificado === false) &&
                                    <Button style={{marginLeft:'5px'}} onClick={ () => this.checkXlsxServer() } className="my-4" color="secondary" type="button" ><i className="fas fa-clipboard-check"></i> {this.props.translate['verificar_dados']}</Button>
                 
                                }
                                {
                                    (this.state.erroXLSX === "" && this.state.verificado === true) &&
                                    <Button onClick={ () => this.cadastrar() } className="my-4" color="success" type="button" ><i className="fas fa-paper-plane"></i> {this.props.translate['cadastrar']}</Button>
                                }
                            </React.Fragment>
                        }
                    </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal></React.Fragment>);

  	}

}

export default connect(state =>({

  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user,

}))(ImportXlsxClassRoom);